goog.declareModuleId('yext.storm.routes');

import {route} from '/js/yext/storm/router';

// DO NOT CALL goog.exportSymbol IN THIS FILE.

/** Shared / Chrome */

export const Storm = {
  root: route(''),
};

export const MainDropdown = {
  getDropdownAccounts: route('accounts'),
  getDropdownAccountsJson: route('accounts.json'),
};

export const Root = {
  systemAlerts: route('alerts'),
};

export const Photos = {
  upload: route('photos/upload'),
  uploadObject: route('photos/uploadObject'),
  crop: route('photos/crop'),
  fetch: route('photos/fetch'),
};

export const LinkedAccounts = {
  facebookEventsDefault: route('account/facebookEventsDefault'),
  linkYextGmbAccount: route('account/linkYextGmbAccount'),
};

export const GenericLinkedAccounts = {
  linkedAccounts: route('linkedaccounts/'),
  viewProviderSummary: route('linkedaccounts/:providerId'),
  viewAddProvider: route('linkedaccounts/addProvider'),
  deleteLinkedAccount: route('linkedaccounts/deleteLinkedAccount'),
  createLinkedAccount: route('linkedaccounts/createLinkedAccount'),
  updateLinkedAccount: route('linkedaccounts/updateLinkedAccount'),
  generateAuthorizationUrl: route('linkedaccounts/generateAuthorizationUrl'),
  listLinkedAccounts: route('linkedaccounts/listLinkedAccounts'),
  refreshLinkedAccount: route('linkedaccounts/refreshLinkedAccount'),
  fetchProviders: route('linkedaccounts/fetchProviders'),
  createProvider: route('linkedaccounts/createProvider'),
  updateProvider: route('linkedaccounts/updateProvider'),
  deleteProvider: route('linkedaccounts/deleteProvider'),
  linkAccount: route('linkedaccounts/linkAccount/:linkedAccountId'),
};

/** Locations */

export const LocationEdit = {
  view: route('#'),
  modify: route('#'),
  template: route('#'),
  templateFolderFilter: route('#'),
  templateLocationFilter: route('#'),
  checkTollFreeNumber: route('#'),
  getGalleryJSON: route('#'),
  getTemplateGalleryJSON: route('#'),
  getCategoryKeywordsForm: route('#'),
  updateFacebookView: route('#'),
  getPaymentOptionsForCountry: route('#'),
  getAdvancedCategoriesJSON: route('#'),
  getGoogleAttributesData: route('#'),
  getAvailableTemplateFields: route('#'),
  getAvailableClusterFields: route('#'),
};

/** Entities */
export const EntityManager = {
  entityAdd3: route('entity/add3'),
  viewEntityAdd: route('entity/viewEntityAdd'),
  view: route('entity/edit3'),
  locationLicensePackData: route('account/subscriptions/locationLicensePackData'),
  createEntity: route('entity/add2'),

  // YFB routes
  optInBasicEntity: route('entity/optInBasicEntity'),
  optOutBasicEntity: route('entity/optOutBasicEntity'),
  makeYahooVerificationCall: route('entity/makeYahooVerificationCall'),
  submitVerificationCode: route('entity/submitVerificationCode'),
  getVerificationCallStatus: route('entity/getVerificationCallStatus'),
  requiresReverification: route('entity/requiresReverification'),
  markEntityForReverification: route('entity/markEntityForReverification'),
};

export const AccountSettings = {
  accountSettings: route('account/settings'),
  suggestionSettings: route('account/suggestionSettings'),
  saveSuggestionSettings: route('account/suggestionSettings/saveSettings'),
  updateSocialComplianceSettings: route('account/socialComplianceSettings'),
  updateUgcSettings: route('account/ugcSettings'),
  updateRemovedReviewSettings: route('account/removedReviewSettings'),
  updateDeIdentifiedReviewSettings: route('account/deIdentifiedReviewSettings'),
  categoryListsDownload: route('account/categoryLists/download'),
  saveProductFeature: route('account/productFeatures'),
};

export const Users = {
  getUserAndRolesJson: route('user/getUserAndRolesJson'),
  getUserAndRolesJsonByIds: route('user/getUserAndRolesJsonByIds'),
  getUserGroupsInBusiness: route('user/getUserGroupsInBusiness'),
};

export const LocationSearch = {
  view: route('locations'),
  viewEntities: route('entities'),
  locationsSearchJson: route('locations/search'),
  entitySearchJson: route('locations/entitySearch'),
  getEntityFilter: route('locations/entityFilter'), // DO NOT USE
  getLocationFilter: route('locations/locationFilter'), // DO NOT USE
  getPagesByTermJson: route('locations/pagesByTerm'), // DO NOT USE
  getPartnersForLocation: route('locations/partnersForLocation'), // DO NOT USE
  getPartnersForLocations: route('locations/partnersForLocations'), // DO NOT USE
  queryTotalEntities: route('locations/queryTotalEntities'), // DO NOT USE
  queryTotalLocations: route('locations/queryTotalLocations'), // DO NOT USE
  applySearchToSavedExport: route('locations/:configurationId/applySearchToSavedExport'), // DO NOT USE
};

export const SocialIntro = {
  issuePopupAuthUrl: route('welcome/social/issueAuthUrl'),
};

export const Folders = {
  list: route('folders/list'), // Deprecated, use entities2/fetchFolders
  add: route('folders/add'), // DO NOT USE
};

export const Labels = {
  getPartnersForLabels: route('locations/labels/partners'), // DO NOT USE
};

export const SocialPost = {
  getPartnersForLocation: route('social/partnersForLocation'),
  getPartnersForLocations: route('social/partnersForLocations'),
  getPartnersForFolder: route('social/:folderId/partnersForFolder'),
  getPartnersForFolders: route('social/partnersForFolders'),
  getPartnersForLabels: route('social/partnersForLabels'),
  getPagesByTermJson: route('social/pagesByTerm'),
};

export const SmallBusinessOverview = {
  getListingReport: route('listings/report'),
  getReviews: route('optimize/modules/reviews'),
};

export const LocalOptimizationFlows = {
  updateField: route('welcome/updateField'),
  next: route('welcome/next'),
  serialNext: route('welcome/serialNext'),
  skip: route('welcome/skip'),
  optOut: route('welcome/optOut'),
  doesNotApply: route('welcome/doesNotApply'),
  addEclItem: route('welcome/content/getEnhancedListItem'),
  markCompleted: route('welcome/markCompleted'),
};

export const EnhancedLists = {
  viewListsTable: route('lists/listTableQuery'),
  publishLists: route('lists/publish'),
  countAssociatedLocations: route('lists/countAssoc'),
  listsSearchJson: route('lists/search'),
  getSectionsFull: route('lists/sectionsFull'),
  deleteLists: route('lists/delete'),
  getEvents: route('events/:listId/getevents'),
  parsingProgress: route('lists/parsingProgress'),
  createDownloadId: route('lists/createDownloadId'),
  generateDownloadFile: route('lists/genfile'),
  getDownloadStatus: route('lists/downloadstatus'),
  renderDownloadFile: route('lists/downloadfile'),
  submitListDescription: route('lists/submitDescription'),
  getDeleteDialog: route('lists/deleteDialog'),
};

export const EntityExport = {
  showBasicInfo: route('export/new'),
  sendTest: route('export/manage/:configurationId/sendTest'),
  generateSavedExport: route('export/manage/:configurationId/generateExport'),
  fetchExportProgress: route('export/fetchExportProgress'),
  fetchExport: route('export/:flowSessionId/fetchExport'),
  fetchSavedExport: route('export/manage/:configurationId/fetchSavedExport'),
  manageSavedExport: route('export/manage/:configurationId/basicInfo'),
  fetchViewOption: route('export/fetchViewOption'),
};

export const EntityUpload = {
  new: route('upload/new'),
  generateSummaryFile: route('upload/:flowSessionId/generateSummaryFile'),
  downloadSummaryFile: route('upload/:flowSessionId/downloadSummaryFile'),
  fetchDownloadProgress: route('upload/fetchDownloadProgress'),
  sanityCheck: route('upload/:flowSessionId/sanityCheck'),
  saveConfiguration: route('upload/:flowSessionId/configure'),
  startAnalysis: route('upload/:flowSessionId/analyze'),
};

export const FolderMgmt = {
  singleUse: route('account/foldermgmt/singleUse'),
};

export const ManageSavedExports = {
  sendTest: route('account/exports/:exportId/sendTest'),
};

/** Listings */

export const ListingTasks = {
  view: route('listingTasks/:locationId'),
  selectListing: route('listingTasks/:locationId/selectListing'),
  addListingToPartner: route('listingTasks/:locationId/addListing'),
  selectNoInstagramListing: route('listingTasks/:locationId/selectNoInstagramListing'),
};

export const Listings = {
  contentSyncPolicies: route('account/listingsSyncSettings'),
  contentSyncPoliciesRedirect: route('account/contentSyncPolicies'),
  contentSyncPoliciesUpdateStatus: route('account/listingsSyncSettings/updateStatus'),
  contentSyncPoliciesUpdateBrandSettings: route('account/listingsSyncSettings/updateBrandSettings'),
  contentSyncPoliciesDeleteBrands: route('account/listingsSyncSettings/deleteBrands'),
  contentSyncPoliciesUpdateBusinessDeliverySettings: route('account/listingsSyncSettings/updateBusinessDeliverySettings'),
  createListing: route('listings/createListing'),
  exportListingsCsv: route('listings/export'),
  transition: route('listings/transition'),
  transitionAll: route('listings/transitionAll'),
  transitionStatus: route('listings/transitionStatus'),
  forceSync: route('listings/forceSync'),
  fixListingModal: route('listings/fixListing/modal'),
  fixListingSubmit: route('listings/fixListing/submit'),
  identifyListingModal: route('listings/identifyListing/modal'),
  identifyListingPotentialListings: route('listings/identifyListing/potentialListings'),
  identifyListingSubmit: route('listings/identifyListing/submit'),

  // Google Verification
  selectVerificationOption: route('listings/selectVerificationOption'),
  verificationOptions: route('listings/verificationOptions'),
  verify: route('listings/verify'),
  googleAdmins: route('listings/googleAdmins'),
  inviteAdmin: route('listings/inviteAdmin'),
  getUrlVerificationViewModal: route('listings/verification/getUrlVerificationViewModal'),

  // Google Bulk Verification
  fetchExternalAccounts: route('listings/googleverification/fetchExternalAccounts'),
};

export const EscalateIssues = {
  getUnavailableReasonsOverview: route('escalateIssues/getUnavailableReasonsOverview'),
  submitCreateTicketRequests: route('escalateIssues/submitCreateTicketRequests'),
};

export const PublisherSuggestions = {
  acceptEdits: route('publishersuggestions/accept'),
  rejectEdits: route('publishersuggestions/reject'),
};

export const Reviews = {
  view: route('reviews'),
  exportReviews: route('reviews/export'),
  emailReviews: route('reviews/email'),
  deleteReviews: route('reviews/delete'),
  respondToReview: route('reviews/respondToReview'),
  editReviewResponse: route('reviews/editReviewResponse'),
  deleteReviewResponse: route('reviews/deleteReviewResponse'),
  approveReview: route('reviews/approveReview'),
  flagReview: route('reviews/flagReview'),
};

export const Suppression = {
  cancel: route('suppression/cancel'),
  getDetailsByUrl: route('suppression/getDetailsByUrl'),
  exportSuppressionsCsv: route('suppression/export'),
};

export const Duplicates = {
  view: route('duplicates'),
  detailsByUrl: route('duplicates/detailsByUrl'),
  endorse: route('duplicates/endorse'),
  exportCsv: route('duplicates/export'),
  ignore: route('duplicates/ignore'),
  modal: route('duplicates/modal'),
  modalDatatable: route('duplicates/modalDatatable'),
  locationPickerState: route('duplicates/locationPickerState'),
  locationPickerSearch: route('duplicates/locationPickerSearch'),
  skipConfirmation: route('duplicates/skipConfirmation'),
  suppressByUrl: route('duplicates/suppressByUrl'),
  submitDuplicateUrlModal: route('duplicates/submitduplicatesmodal'),
  submitDuplicateUrl: route('duplicates/submitduplicates'),
  getRelevantPublishers: route('duplicates/getRelevantPublishers'),
  getOverview: route('duplicates/getOverview'),
  optOut: route('duplicates/disableDuplicateSuppression'),
};

export const ScheduledUpdates = {
  getFieldsForAction: route('scheduledupdates/getFieldsForAction'),
  reschedule: route('scheduledupdates/reschedule'),
  cancel: route('scheduledupdates/cancel'),
  revert: route('scheduledupdates/revert'),
};

export const EntityScheduledUpdates = {
  getFieldsForAction: route('entity/scheduledupdates/fields'),
  reschedule: route('entity/scheduledupdates/reschedule'),
  cancel: route('entity/scheduledupdates/cancel'),
  revert: route('entity/scheduledupdates/revert'),
};

export const Templates = {
  updateFieldData: route('templates/:templateId/updateFieldData'),
  updateFields2: route('templates/:templateId/updateFields2'),
};

// FieldsStorm
export const FieldsStorm = {
  createCustomFieldType: route('account/customFieldTypes/create'),
  viewCustomFieldTypes: route('account/customFieldTypes'),
  updateCustomFieldType: route('account/customFieldTypes/:customFieldTypeId/edit'),
  deleteCustomFieldType: route('account/customFieldTypes/delete'),
  listCustomFieldTypes: route('account/customFieldTypes'),

  listCustomFieldGroups: route('account/customFieldGroups'),
  createCustomFieldGroup: route('account/customFieldGroups'),
  updateCustomFieldGroup: route('account/customFieldGroups/:customFieldGroupId'),
  deleteCustomFieldGroup: route('account/customFieldGroups/:customFieldGroupId'),

  viewData: route('account/customFields/viewData'),
};

// EntityTypesStorm
export const EntityTypesStorm = {
  updateCustomEntityTypeSettings: route('account/entitytypes/:entityTypeId/settings'),
  editCustomEntityTypeSettings: route('account/entitytypes/:entityTypeId/settings'),
  listEntityTypes: route('account/entitytypes'),
  createCustomEntityType: route('account/entitytypes/new'),
  editFieldConfiguration: route('account/entitytypes/:entityTypeId/configureFields'),
  fetchBrowserFields: route('account/entitytypes/:entityTypeId/fetchBrowserFields'),
  fetchOtherConfigurations: route('account/entitytypes/:entityTypeId/fetchOtherConfigurations'),

  viewEntityType: route('account/entitytypes/:entityTypeId'),
  viewEntityTypeFieldTab: route('account/entitytypes/:entityTypeId?tab=configureFields'),
  fetchSettings: route('account/entitytypes/:entityTypeId/settingsJson'),
  fetchFieldConfiguration: route('account/entitytypes/:entityTypeId/configureFieldsJson'),
  fetchEntityPreview: route('account/entitytypes/:entityTypeId/preview'),
  editEntityPreview: route('account/entitytypes/:entityTypeId/preview'),
};

export const Answers = {
  answersConfig: route('search/experiences/configuration'),
};

// Data Ingestion
export const DataIngestion = {
  addData: route('addData/'),
  fetchAddDataContent: route('addData/fetchAddDataContent'),
  viewConnectors: route('addData/connectors'),
  createConnector: route('addData/connectors/createConnector'),
  duplicateConnector: route('addData/connectors/duplicateConnector'),
  updateConnector: route('addData/connectors/updateConnector'),
  deleteConnector: route('addData/connectors/deleteConnector'),
  viewConnectorSummary: route('addData/connectors/:configurationId'),
  configureConnector: route('addData/connectors/:configurationId/configure'),
  fetchData: route('addData/connectors/fetchData'),
  fetchSelectors: route('addData/connectors/fetchSelectors'),
  extractData: route('addData/connectors/extractData'),
  applyTransforms: route('addData/connectors/applyTransforms'),
  generateMappings: route('addData/connectors/generateMappings'),
  generateMappingStatus: route('addData/connectors/generateMappingStatus'),
  enableEntityType: route('addData/enableEntityType/:entityTypeId'),
  fetchCrawlers: route('addData/fetchCrawlers'),
  fetchUrls: route('addData/fetchUrls'),
  fetchFieldNodes: route('addData/fetchFieldNodes'),
  fetchVariableFieldNodes: route('addData/fetchVariableFieldNodes'),
  fetchFlows: route('addData/connectors/fetchFlows'),
  startFlow: route('addData/connectors/startFlow'),
  cancelFlow: route('addData/connectors/cancelFlow'),
  approveFlow: route('addData/connectors/approveFlow'),
  downloadFlowResults: route('addData/downloadFlowResults'),
  createApp: route('addData/createApp'),
  fetchApps: route('addData/fetchApps'),
  fetchPlugins: route('addData/fetchPlugins'),
  fetchLinkedAccounts: route('addData/fetchLinkedAccounts'),
  fetchMappedPublishers: route('addData/fetchMappedPublishers'),
  fetchCurrentFile: route('addData/fetchCurrentFile/:configurationId'),
  uploadFile: route('addData/uploadFile/:configurationId'),
  downloadFile: route('addData/downloadFile'),
  fetchSavedSearches: route('addData/fetchSavedSearches'),
  fetchBusinessTemplates: route('addData/fetchBusinessTemplates'),
  fetchTemplateFieldNodes: route('addData/fetchTemplateFieldNodes'),
  viewRunResults: route('addData/connectors/:configurationId/runs/:flowId'),
  fetchTriggeredConnectors: route('addData/fetchTriggeredConnectors/:triggerId'),
  fetchEntityResults: route('addData/fetchEntityResults'),
  fetchETLDiagnostics: route('addData/fetchETLDiagnostics'),
  fetchEntityFailures: route('addData/fetchEntityFailures'),
  fetchApiResults: route('addData/fetchApiResults'),
  fetchApiResultDetails: route('addData/fetchApiResultDetails/:requestUuid'),
  listFields: route('addData/listFields'),
  fetchEntityData: route('addData/fetchEntityData'),
  fetchDateTimeFormatOptions: route('addData/fetchDateTimeFormatOptions'),
  generateVariables: route('addData/generateVariables'),
  generateApiRequestPreview: route('addData/connectors/generateApiRequestPreview'),
  fetchEntityFieldData: route('addData/fetchEntityFieldData'),
  viewScoutTemplate: route('addData/scout'),
  triggerScoutFlow: route('addData/scout/triggerScoutFlow'),
};

// Entity Jobs
export const EntityJobs = {
  fetchJobs: route('account/entityjobs/fetchJobs'),
  view: route('account/entityjobs/'),
  cancelJob: route('account/entityjobs/cancelJob'),
  downloadJobResults: route('account/entityjobs/downloadJobResults'),
};

// Entity History
export const EntityHistory = {
  viewEntityHistory: route('account/entityhistory/'),
  viewOperation: route('account/entityhistory/operation/:operationId'),
  fetchFieldEventDetails: route('account/entityhistory/fetchFieldEventDetails'),
  fetchHistory: route('account/entityhistory/fetchHistory'),
  fetchEntityOperations: route('account/entityhistory/fetchOperations'),
  fetchOperationMetadata: route('account/entityhistory/fetchOperationMetadata'),
  listFields: route('account/entityhistory/listFields'),
  listLocales: route('account/entityhistory/listLocales'),
  reapplyEvents: route('account/entityhistory/reapplyEvents'),
  undoEvents: route('account/entityhistory/undoEvents'),
  reapplyOperation: route('account/entityhistory/reapplyOperation'),
  undoOperation: route('account/entityhistory/undoOperation'),
};

export const Crawler = {
  addCrawler: route('account/crawlers/add'),
  viewCrawlers: route('account/crawlers/:crawlerId'),
};

// EntitySearchStorm
export const EntitySearchStorm = {
  entities2: route('entities2'),

  // datatable
  fetchRows: route('entities2/fetchRows'),

  // grid view
  fetchCards: route('entities2/fetchCards'),

  // filter bar
  fetchFilterTypes: route('entities2/filterbar/fetchFilterTypes'),
  fetchExtraTypeContext: route('entities2/filterbar/fetchExtraTypeContext'),
  queryExtraTypeContext: route('entities2/filterbar/queryExtraTypeContext'),

  // sidebar
  fetchEntityTypes: route('entities2/sidebar/fetchEntityTypes'),
  fetchFolders: route('entities2/fetchFolders'),
  addFolder: route('entities2/sidebar/addFolder'),
  renameFolder: route('entities2/sidebar/renameFolder'),
  deleteFolder: route('entities2/sidebar/deleteFolder'),
  moveFolder: route('entities2/sidebar/moveFolder'),

  // labels
  listLabels: route('entities2/labels'),
  createLabel: route('entities2/labels'),
  updateLabel: route('entities2/labels/:labelUid'),
  deleteLabels: route('entities2/deleteLabels'),

  savePinnedFilters: route('entities2/sidebar/savePinnedFilters'),

  // bulk actions
  fetchBulkActions: route('entities2/fetchBulkActions'),
  cacheFilters: route('entities2/cacheFilters'),
  moveToFolder: route('entities2/actions/moveToFolder'),
  applySearchToSavedExport: route('entities2/actions/applySearchToSavedExport'),
  deleteEntities: route('entities2/actions/deleteEntities'),
  fetchBulkComputationData: route('entities2/actions/fetchBulkComputationData'),
  createComputationOperation: route('entities2/actions/createComputationOperation'),

  // saved filters
  fetchSavedFilters: route('entities2/fetchSavedFilters'),
  createSavedFilter: route('entities2/savedFilters/create'),
  updateSavedFilter: route('entities2/savedFilters/update'),
  renameSavedFilter: route('entities2/savedFilters/rename'),
  deleteSavedFilter: route('entities2/savedFilters/delete'),

  listSavedFilters: route('account/savedFilters'),
};

// Resellers
export const Resellers = {
  onboarding: route('resellers/onboarding'),
};

// KnowledgeGraphSettingsStorm
export const KnowledgeGraphSettingsStorm = {
  viewSettings: route('knowledgegraph'),
  viewConfiguration: route('knowledgegraph/configuration'),
};

// ForkFieldsStorm
export const ForkFieldsStorm = {
  forkFieldsHistory: route('forkFieldsHistory'),
  forkFieldTypes: route('forkFieldTypes'),
  forkFields: route('forkFields'),
  fetchForkFieldsJob: route('fetchForkFieldsJob'),
  downloadJobResults: route('forkFieldsHistory/downloadJobResults'),
};

// DataSuggestionStorm
export const DataSuggestionStorm = {
  flaggedTerms: route('account/flaggedTerms/'),
  reassignFlaggedTerms: route('account/flaggedTerms/reassign'),
  termLabels: route('account/termLabels/'),
  saveTermLabel: route('account/termLabels/save'),
  deleteTermLabel: route('account/termLabels/delete'),
  view2: route('suggestions/search'),
};

// Entity Features
export const EntityFeatures = {
  add: route('entityfeatures/add'),
  remove: route('entityfeatures/remove'),
};

// Subscriptions
export const Subscriptions = {
  addOld: route('account/subscriptions/add'),
  removeOld: route('account/subscriptions/removeLocations'),
  addNew: route('account/subscriptions/services/add'),
  removeNew: route('account/subscriptions/services/remove'),
  getChooseLocationDropdown: route('account/subscriptions/services/getDropdown'),
  subscriptionLocationsSearchJson: route('account/subscriptions/services/locationsearch'),
  previewAddServices: route('account/subscriptions/services/previewaddservices'),
  previewRemoveServices: route('account/subscriptions/services/previewremoveservices'),
  getChooseVoltronLocationDropdown: route('account/subscriptions/services/getVoltronDropdown'),
  updateVoltronLocations: route('account/subscriptions/services/updateVoltronLocations'),
  voltronAddCheckout: route('account/subscriptions/services/confirmAddVoltronLocations'),
  voltronRemoveCheckout: route('account/subscriptions/services/confirmRemoveVoltronLocations'),
  duplicateCheck: route('account/subscriptions/services/duplicateCheck'),
  stopServices: route('account/subscriptions/stopServices'),
  assignLicenses: route('licenses/subscriptions/assign/selectLicenses'),
  unassignLicenses: route('licenses/subscriptions/unassign/selectOptions'),
};

// LaunchFlowStorm
export const LaunchFlowStorm = {
  add: route('launch/add'),
  remove: route('launch/remove'),
};

// Agreements
export const Agreements = {
  add: route('agreements/add'),
  remove: route('agreements/cancelservice/selectServices'),
};

// Holiday Hours
export const HolidayHours = {
  upload: route('holidayHours/upload'),
};

// Developer Logs
export const DeveloperLogs = {
  viewFunctionLogs: route('developer/logs/functions'),
  fetchFunctionInvocations: route('developer/logs/fetchFunctionInvocations'),
  fetchFunctionFetches: route('developer/logs/fetchFunctionFetches'),
  listFunctionCallers: route('developer/logs/listFunctionCallers'),
  fetchFunctionInvocationDetails: route('developer/logs/fetchFunctionInvocationDetails'),
  fetchRuntimeDetails: route('developer/logs/fetchRuntimeDetails'),
  fetchResponseDetails: route('developer/logs/fetchResponseDetails'),
};

export const TemplatesStorm = {
  addTemplate: route('templates/add'),
  editTemplate: route('templates/:templateId/edit'),
  deleteTemplate: route('templates/:templateId/delete2'),
};

export const ZendeskStorm = {
  listTickets: route('tickets/'),
  newTicket: route('tickets/new'),
};
